import React, { Component } from 'react';
import { Line } from 'rc-progress';
import TestReport from './test_report';

export default class TestCase extends Component {
  constructor(props) {
    super(props);
    this.events = {
      errors: [],
      warnings: [],
      success: [],
      info: [],
      events: [],
    };
    this.state = {
      progress: 0,
      testState: "unstarted",
    };
    this.setTimeoutWithProgressBar = this.setTimeoutWithProgressBar.bind(this);
    this.onRunTest = this.onRunTest.bind(this);
  }

  componentDidUpdate() {
    if (this.props.automaticRun === true &&  this.state.testState === "unstarted") {
      this.setState({ progress: 0, testState: "started" });
      this.props.runnable.run(this, this.props.device);
    }
  }

  reportError(error) {
    this.events.errors.push(error);
  }

  reportFatal(fatal) {
    this.events.errors.push(`Fatal: ${fatal}`);
  }

  reportWarning(warning) {
    this.events.warnings.push(warning);
  }

  reportSuccess(success) {
    this.events.success.push(success);
  }

  reportInfo(info) {
    this.events.info.push(info);
  }

  setTimeoutWithProgressBar(timeoutCallback, timeoutMs) {
    var self = this;
    var start = window.performance.now();
    var updateProgressBar = setInterval(function() {
      var now = window.performance.now();
      console.log((now - start) * 100 / timeoutMs);
      self.setState({ progress: (now - start) * 100 / timeoutMs });
    }, 100);
    var timeoutTask = function() {
      clearInterval(updateProgressBar);
      console.log(100);
      self.setState({ progress: 100, testState: "done", events: self.events });
      timeoutCallback();
    };
    var timer = setTimeout(timeoutTask, timeoutMs);
    var finishProgressBar = function() {
      clearTimeout(timer);
      timeoutTask();
    };
    return finishProgressBar;
  }

  onRunTest() {
    console.log("Using device " + this.props.device, this.props.runnable);
    this.setState({ progress: 0, testState: "started" });
    this.props.runnable.run(this, this.props.device);
  }

  done() {
    console.log(`# Errors = ${this.events.errors.length}`);
    console.log("Errors are: ");
    this.events.errors.forEach( e => console.log(` - ${e}`));

    console.log(`# Warnings = ${this.events.warnings.length}`);
    console.log("Warnings are: ");
    this.events.warnings.forEach( e => console.log(` - ${e}`));

    console.log(`# Success = ${this.events.success.length}`);
    console.log("Success are: ");
    this.events.success.forEach( e => console.log(` - ${e}`));

    console.log(`# Info = ${this.events.info.length}`);
    console.log("Info are: ");
    this.events.info.forEach( e => console.log(` - ${e}`));

    this.setState({ testState: "done", events: this.events });
    this.props.onFinish(this.events.errors.length === 0);
  }

  render() {
    if (this.props.runnable == null) {
      return null;
    }
    return (
      <div>
        {
          this.props.automaticRun  === undefined &&
            <div className={"form-group text-center"}>
              <button type="button" className="btn btn-default" onClick={this.onRunTest}>Ejecutar Test</button>
            </div>
        }
        {
          !this.props.multiple &&
            <p>
              Progreso:
              <Line percent={this.state.progress} strokeWidth="3" strokeColor="var(--primary-color)" />
            </p>
        }
        { (!this.props.multiple || this.props.last) && <TestReport testState={this.state.testState} events={this.state.events}/> }
      </div>
    );
  }
}
